export default __webpack_public_path__ + "static/media/tx-latest.d49cca4c.svg";